import React, { useContext, useEffect, useReducer, useMemo } from 'react';
import { lockedReducer } from '../Utils/reducers';
import { api } from '../../services/api';
import { Box, IconButton, Tooltip, TextField } from '@mui/material';
import ColorButton from '../Buttons/ColorButton';
import Table, { TableHook } from '../Table';
import { externalComponent } from '../AppRoutes';
import { convertDateFormat } from '../Utils/functions';
import { number2dayweek } from '../Utils/dayjsptbrhelper';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
import toast from 'react-hot-toast';

const GraficosIndex = () => {

    const currentDate = new Date();
    const threeMonthsAgo = new Date();

    threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 1);

    threeMonthsAgo.setDate(1);

    const dtIni = convertDateFormat(threeMonthsAgo)
    const dtFim = convertDateFormat(currentDate)


    const [state, setState] = useReducer(lockedReducer, {
        rows: [],
        rowsReset: [],
        dtIni: dtIni,
        dtFim: dtFim

    })

    const { setLoader } = useContext(externalComponent)

    useEffect(() => {



    }, [])

    return (
        <>
            <Box>

            </Box>
        </>
    )
}

export default GraficosIndex;